// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jG4m","expireSoon":"styles_expireSoon__1dOvN"};